import React from 'react'

interface IconProps {
  size?: number
  color?: string
  strokeWidth?: number
  className?: string
  tooltipText?: string
}

export const ExchangeIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
  tooltipText,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {tooltipText && <title>{tooltipText}</title>}
      {/* Top arrow - right to left */}
      <path d="M7 10L3 6L7 2" />
      <path d="M21 6H3" />

      {/* Bottom arrow - left to right */}
      <path d="M17 14L21 18L17 22" />
      <path d="M3 18H21" />
    </svg>
  )
}

export default ExchangeIcon
